import { Component, Input, OnInit, inject } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { RapidReviewExamRecapFormattedResponse, RapidReviewModalService } from '@shared/component/rapid-review-modal/rapid-review-modal.service';
import { PrescriptionUtil } from '@core/prescription-util/prescription-util';
import { RapidReviewTestComponent } from '@shared/component/rapid-review-modal/rapid-review-test/rapid-review-test.component';
import { EnumUtil } from 'morgana';
import { PrescriptionCurrentStatus } from '@gandalf/constants';
import { DATE_FORMATS } from '@shared/constants/date-format.constants';

@Component({
	selector: 'pms-rapid-review-exam-recap',
	imports: [SharedModule, RapidReviewTestComponent],
	templateUrl: './rapid-review-exam-recap.component.html',
})
export class RapidReviewExamRecapComponent implements OnInit{
	private rapidReviewModalService = inject(RapidReviewModalService);

	@Input({required: true})
	encounterId: number;
	examRecap: RapidReviewExamRecapFormattedResponse;
	protected readonly PrescriptionUtil = PrescriptionUtil;
	dateFormat: string = DATE_FORMATS.MM_DD_YYYY;

	ngOnInit(): void {
		this.rapidReviewModalService.getRapidReviewExamRecap(this.encounterId).subscribe( response => this.examRecap = response);
	}

	isPending(status: PrescriptionCurrentStatus): boolean {
		return EnumUtil.equals(status, PrescriptionCurrentStatus.PENDING);
	}

	isExpired(status: PrescriptionCurrentStatus): boolean {
		return EnumUtil.equals(status, PrescriptionCurrentStatus.EXPIRED);
	}
}
